import { useContext, useState, useEffect } from "react";

//Components
import Timer from "../Timer";
import {
  TableRow,
  TableBody,
  TableCell,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";

//Contexts
import { UserContext } from "../../Contexts/UserContext";
import { SetupContext } from "../../Contexts/SetupContext";

//Styles
import { useStyles } from "../../Styles/styles";
import { withStyles } from "@material-ui/core/styles";
//Utils
import { canEditAvailableOfficers } from "../../utils/Roles";
import RadioLogModal from "../RadioLogModal";
import { useToggle } from "../../CustomHooks/useToggle";
import { getOriColor } from "../../Styles/getOriColor";
import { useCookies } from "react-cookie";

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
      padding: 0,
    },
  },
}))(TableRow);

const StyledTableCell = withStyles(() => ({
  root: {
    borderRight: "2px solid #e3e2e2",
    textAlign: "center",
    padding: 0,
  },
}))(TableCell);

const CODES_FOR_INCIDENT_STATUS = [
  "23/",
  "24/",
  "76/",
  "89/",
  "90/",
  "D/",
  "S/",
];

const ActiveIncidentTableRows = ({
  handleIncidentOpening,
  rows,
  handleSecondaryLocationUpdate,
  handleStatusChange,
  handleSetLastContactedAt,
  setSelectedCell,
  selectedCell,
  handleSetAvailOfficer,
  showColumn,
  userPreferences,
}) => {
  const { user } = useContext(UserContext);
  const { setup } = useContext(SetupContext);
  const classes = useStyles();

  const [showChild, setShowChild] = useState(null);
  const [showRadioModal, toggleRadioModal] = useToggle(false);
  const [selectedOfficer, setSelectedOfficer] = useState({});

  useEffect(() => {
    if (!showRadioModal) {
      setSelectedOfficer({});
    }
  }, [showRadioModal]);
  // const CODES_FOR_ACTIVE_UNIT_STATUS = ["7/", "8/", "10L/", "21/", "38/", "75/", "80/", "PW", "T/", "ATT/"]

  // const codesForIncidentStatus = useMemo(
  //   () =>
  //     setup?.setupLists?.logCodes?.filter(lc =>
  //       CODES_FOR_INCIDENT_STATUS.some(el => lc?.name?.startsWith(el))
  //     ),
  //   [setup?.setupLists?.logCodes]
  // );
  // const codesForActiveUnitStatus = useMemo(() => setup?.setupLists?.logCodes?.filter(lc => CODES_FOR_ACTIVE_UNIT_STATUS.some(el => lc?.name?.startsWith(el))), [setup?.setupLists?.logCodes])
  const [cookies] = useCookies();
  const nightMode = cookies[`mp-userId-${user?.id}-night-mode`] === "true";

  return (
    <TableBody data-testid="active-incident-table-body">
      {rows.map((row, index) => {
        const slashIndex = row?.ois?.currentOfficerStatus?.indexOf("/");
        const tenCode = row?.ois?.currentOfficerStatus?.substring(
          0,
          slashIndex
        );
        const allowedToEdit = canEditAvailableOfficers(
          user,
          row?.incidentOriId,
          row?.officerId
        );
        const callTime = row?.officerId ? row?.ois?.createdAt : row?.callTime;
        return (
          <StyledTableRow
            style={{
              display:
                row.child && row.incidentId !== showChild
                  ? "none"
                  : "table-row",
            }}
            key={row.oisId}
          >
            <StyledTableCell
              data-testid="incident-number-cell"
              className={classes.tableCellBorder}
              style={{
                display: showColumn.incidentNumber ? "" : "none",
                backgroundColor: getOriColor(
                  row?.incidentOriId,
                  nightMode,
                  userPreferences
                ),
              }}
              data-cy={"tablecell-incident-number-" + index}
              align="left"
              component="td"
              scope="row"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  wrap: "nowrap",
                  justifyContent: "center",
                }}
              >
                <button
                  data-testid="incident-number-button"
                  style={{ marginLeft: row.child ? "10px" : "" }}
                  className={
                    row?.disabled
                      ? classes.linkButtonDisabled
                      : classes.linkButton
                  }
                  data-cy={"tablecell-incident-number-link-" + index}
                  onClick={
                    row?.disabled
                      ? () =>
                          alert(
                            "You do not have permission to view this incident"
                          )
                      : () => {
                          handleIncidentOpening(row.incidentId, true);
                        }
                  }
                >
                  {row.incidentNumber}
                </button>
                {row.parent && (
                  <IconButton
                    data-testid="incident-chevron"
                    size="small"
                    onClick={() =>
                      setShowChild(
                        showChild === row.incidentId ? null : row.incidentId
                      )
                    }
                  >
                    {row.incidentId === showChild ? (
                      <ExpandMoreIcon />
                    ) : (
                      <ChevronLeftIcon />
                    )}
                  </IconButton>
                )}
              </div>
            </StyledTableCell>
            <StyledTableCell
              data-testid="badge-cell"
              className={classes.tableCellBorder}
              style={{
                display: showColumn.badge ? "" : "none",
                fontWeight: row.primaryOfficer ? "bold" : "",
                cursor: allowedToEdit && row?.officerId ? "pointer" : "inherit",
                backgroundColor: getOriColor(
                  row?.ori?.id,
                  nightMode,
                  userPreferences
                ),
              }}
              data-cy="tablecell-badge"
              align="left"
              onClick={() => {
                if (allowedToEdit && row?.badge) {
                  toggleRadioModal();
                  setSelectedOfficer({
                    badge: row?.ori?.abbreviation + "-" + row?.badge,
                    id: row?.officerId,
                    oisId: row?.oisId,
                  });
                }
              }}
            >
              {row.badge}
            </StyledTableCell>
            <StyledTableCell
              data-testid="assignment-cell"
              onClick={() => {
                row?.officerId &&
                  setSelectedCell(row.officerId + "-assignment");
              }}
              className={classes.tableCellBorder}
              style={{
                display: showColumn.assignment ? "" : "none",
                cursor: allowedToEdit && row?.officerId ? "pointer" : "",
              }}
              data-cy="tablecell-assignment"
              align="left"
            >
              {selectedCell === row?.officerId + "-assignment" &&
              allowedToEdit ? (
                <TextField
                  data-testid="assignment-textfield"
                  multiline={true}
                  name="assignment"
                  disabled={!allowedToEdit || !row?.officerId}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      e.target.blur();
                    }
                  }}
                  onBlur={e => handleSetAvailOfficer(e, row)}
                  defaultValue={row.assignment ? row.assignment : ""}
                  autoComplete="off"
                  margin="dense"
                  style={{ padding: 0, margin: 0, width: "95%" }}
                />
              ) : (
                <p>
                  {row.assignment}
                  {row?.loanerOriAbbreviations
                    ? "/" + row.loanerOriAbbreviations
                    : ""}
                </p>
              )}
            </StyledTableCell>
            <StyledTableCell
              data-testid="call-type-cell"
              className={classes.tableCellBorder}
              style={{
                display: showColumn.type ? "" : "none",
                color: row.callTypeColor,
              }}
              data-cy="tablecell-type"
              align="left"
            >
              {row.type}
            </StyledTableCell>
            <StyledTableCell
              data-testid="location-cell"
              className={classes.tableCellBorder}
              style={{
                display: showColumn.location ? "" : "none",
                color: row.locationColor,
              }}
              data-cy="tablecell-location"
              align="left"
            >
              <Typography className={classes.insideTableCell} noWrap={true}>
                {row.location}
              </Typography>
            </StyledTableCell>
            <StyledTableCell
              data-testid="ofc-status-cell"
              className={classes.tableCellBorder}
              style={{ display: showColumn.officerStatus ? "" : "none" }}
              data-cy="tablecell-officer-status"
              align="left"
            >
              {row?.officerStatus}
            </StyledTableCell>
            <StyledTableCell
              className={classes.tableCellBorder}
              style={{
                display: showColumn.secondaryAddress ? "" : "none",
                maxWidth: "10vw",
                cursor: allowedToEdit && row?.officerId ? "pointer" : "",
              }}
              data-cy="tablecell-secondary-address"
              data-testid="secondary-address-cell"
              align="left"
              onClick={() => {
                row?.officerId &&
                  setSelectedCell(row.officerId + "-secondaryAddress");
              }}
            >
              {selectedCell === row?.officerId + "-secondaryAddress" &&
              allowedToEdit ? (
                <TextField
                  data-testid="secondaryAddress-textfield"
                  multiline={true}
                  name="secondaryAddress"
                  disabled={!allowedToEdit}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      e.target.blur();
                    }
                  }}
                  onBlur={e =>
                    handleSecondaryLocationUpdate(
                      e.target.value,
                      row.oisId,
                      row.incidentId
                    )
                  }
                  defaultValue={
                    row.secondaryAddress ? row.secondaryAddress : ""
                  }
                  autoComplete="off"
                  margin="dense"
                  style={{ padding: 0, margin: 0, width: "95%" }}
                />
              ) : (
                <p style={{ margin: "0px" }}>
                  {row?.secondaryAddress?.substring(0, 128)}
                </p>
              )}
            </StyledTableCell>

            <StyledTableCell
              data-testid="incident-status-cell"
              className={classes.tableCellBorder}
              style={{ display: showColumn.status ? "" : "none" }}
              data-cy="tablecell-status"
              align="left"
            >
              {allowedToEdit && row?.officerId ? (
                <Select
                  data-testid="incident-status-select"
                  id="incident-status-select"
                  disabled={!allowedToEdit}
                  // value={row?.logCodeId || ""}
                  value={row.logCode || ""}
                  // value={
                  //   setup?.setupLists?.logCodes.find(
                  //     lc => lc?.id === row?.logCodeId
                  //   ) || ""
                  // }
                  onChange={e => handleStatusChange(e, row)}
                  // renderValue={value => {
                  //   return tenCode || "";
                  // }}
                  renderValue={value => {
                    const slashIndex = value?.name?.indexOf("/");
                    const tenCode = value?.name?.substring(0, slashIndex);

                    return tenCode || value;
                  }}
                >
                  {setup?.setupLists?.logCodes &&
                    setup?.setupLists?.logCodes?.map(logCode => {
                      const hide = !CODES_FOR_INCIDENT_STATUS.some(el =>
                        logCode?.name?.startsWith(el)
                      );
                      const styleObj = hide ? { display: "none" } : {};
                      return (
                        <MenuItem
                          key={logCode.id}
                          value={logCode}
                          style={styleObj}
                        >
                          {logCode.name}
                        </MenuItem>
                      );
                    })}
                </Select>
              ) : (
                tenCode
              )}
            </StyledTableCell>
            <StyledTableCell
              data-testid="on-scene-cell"
              className={classes.tableCellBorder}
              style={{ display: showColumn.onSceneAt ? "" : "none" }}
              data-cy="tablecell-on-scene"
              align="left"
            >
              <Timer startTime={row.onSceneAt} type={"onSceneAt"} />
            </StyledTableCell>
            <StyledTableCell
              className={classes.tableCellBorder}
              style={
                allowedToEdit && row?.officerId
                  ? {
                      display: showColumn.officerTimer ? "" : "none",
                      cursor: "pointer",
                    }
                  : { display: showColumn.officerTimer ? "" : "none" }
              }
              data-cy="tablecell-ofc-timer"
              data-testid="ofc-timer-cell"
              align="left"
              onClick={() =>
                row?.officerId && handleSetLastContactedAt(row.officerId, row)
              }
              disabled={!allowedToEdit || !row?.officerId}
            >
              {row.badge ? (
                <Timer startTime={row.lastContactedAt} type={"officer"} />
              ) : null}
            </StyledTableCell>
            <StyledTableCell
              data-testid="call-timer-cell"
              className={classes.tableCellBorder}
              style={{ display: showColumn.callTimer ? "" : "none" }}
              data-cy="tablecell-call-timer"
              align="left"
            >
              <Timer startTime={callTime} type={"incident"} />
            </StyledTableCell>
            <StyledTableCell
              data-testid="car-number-cell"
              className={classes.tableCellBorder}
              style={
                allowedToEdit
                  ? {
                      cursor: "pointer",
                      display: showColumn.carNumber ? "" : "none",
                      minWidth: "5vw",
                    }
                  : {
                      display: showColumn.carNumber ? "" : "none",
                      minWidth: "5vw",
                    }
              }
              data-cy="tablecell-car-number"
              onClick={() => {
                setSelectedCell(row.officerId + "-carNumber");
              }}
              align="left"
            >
              {allowedToEdit ? (
                <TextField
                  data-testid="carNumber-textfield"
                  className={classes.insideTableCell}
                  name="carNumber"
                  disabled={!allowedToEdit || !row?.officerId}
                  multiline={true}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      handleSetAvailOfficer(e, row);
                    }
                    if (e.key === "Escape") {
                      setSelectedCell("");
                    }
                  }}
                  onBlur={e => handleSetAvailOfficer(e, row)}
                  defaultValue={row.carNumber ? row.carNumber : ""}
                />
              ) : (
                <Typography className={classes.insideTableCell} noWrap={true}>
                  {row.carNumber}
                </Typography>
              )}
            </StyledTableCell>
            <StyledTableCell
              data-testid="radio-number-cell"
              className={classes.tableCellBorder}
              style={
                allowedToEdit
                  ? {
                      cursor: "pointer",
                      display: showColumn.radioNumber ? "" : "none",
                      minWidth: "5vw",
                    }
                  : {
                      display: showColumn.radioNumber ? "" : "none",
                      minWidth: "5vw",
                    }
              }
              data-cy="tablecell-radio-number"
              onClick={() => {
                setSelectedCell(row.officerId + "-radioNumber");
              }}
              align="left"
            >
              {allowedToEdit ? (
                <TextField
                  data-testid="radioNumber-textfield"
                  className={classes.insideTableCell}
                  name="radioNumber"
                  disabled={!allowedToEdit || !row?.officerId}
                  multiline={true}
                  onKeyDown={e => {
                    if (e.key === "Enter") {
                      handleSetAvailOfficer(e, row);
                    }
                    if (e.key === "Escape") {
                      setSelectedCell("");
                    }
                  }}
                  onBlur={e => handleSetAvailOfficer(e, row)}
                  defaultValue={row.radioNumber ? row.radioNumber : ""}
                />
              ) : (
                <Typography className={classes.insideTableCell} noWrap={true}>
                  {row.radioNumber}
                </Typography>
              )}
            </StyledTableCell>
          </StyledTableRow>
        );
      })}
      <RadioLogModal
        officer={selectedOfficer}
        modalOpen={showRadioModal}
        setModalOpen={toggleRadioModal}
        incident={null}
        incidents={null}
      />
    </TableBody>
  );
};

export default ActiveIncidentTableRows;
